import { appStore } from '../../app/AppStore';
import { siteUrlsSelector } from '../../app/selectors/SiteUrlsSelectors';
import { Messages } from '../../codegen/Localize';
import { Location } from '../../common/react/Location';
import { IDataSourceBase, IDataSourceDetailInfo} from '../models/IDataSourceInfo';
import { IRemoteRefreshPropertiesInfo } from '../models/IRemoteRefreshPropertiesInfo';
import {IExtractItemInfo, ISpaceTypeInfo} from '../models/resourceInfoParts';
import { RemoteRefreshTypes } from '../ServerApi/requests/GetRemoteRefreshSchedulesRequest';
import { RefreshModeTypes } from '../ServerApi/types/IRemoteRefreshProperties';

export module RefreshPropertyHelper {

  export function getAvailableRefreshTypes(item: IExtractItemInfo): string[] {
    const types: string[] = [];
    types.push(RemoteRefreshTypes.Full);

    if (item.hasIncrementalExtract) {
      types.push(RemoteRefreshTypes.Incremental);
    }

    return types;
  }

  export function canBeRefreshedRemotely(datasource: IDataSourceBase): boolean {
    // To be refreshed remotely (on a sync client) the datasource must have an extract and not be OAuth.
    return datasource.hasExtracts &&
      datasource.contentType === 'datasource' &&
      !(datasource.connectionOAuth &&
        datasource.connectionDetails &&
        datasource.connectionDetails.type === 'database');
  }

  export function getCurrentRefreshLocation(refreshed: IRemoteRefreshPropertiesInfo): string {
    if (refreshed && refreshed.refreshMode === RefreshModeTypes.Remote && refreshed.remoteAgentName) {
      return refreshed.remoteAgentName;
    } else if (refreshed && refreshed.refreshMode === RefreshModeTypes.Remote && refreshed.remoteAgentReservationId) {
      return Messages.remoteRefreshModeReservedLabel();
    } else if (refreshed && refreshed.refreshMode === RefreshModeTypes.Remote && !refreshed.remoteAgentName) {
      return Messages.remoteRefreshModeUnlinkedLabel();
    } else {
      return Messages.remoteRefreshModeServerLabel();
    }
  }

  // Prevent deep links to the incorrect refresh schedules page
  // 'extractTasks' is the default state
  export function redirectByDatasourceRefreshMode(refreshMode: string, dsId: string): void {
    // I'm 95% sure this code doesn't even get hit anymore with stylishDatasources. I'm 99% sure it will no
    // longer get hit with stylishTasks.

    // Don't assume the refresh mode property is defined. If it isn't 'extractTasks' is the default state.
    const url = window.location.href;
    if ((url.includes('localExtractRefreshes') || url.includes('publishresult'))
      && refreshMode !== RefreshModeTypes.Remote) {

      const siteUrls = siteUrlsSelector(appStore.getState());
      Location.instance.setUrl(siteUrls.datasourceExtractRefreshesUrl(dsId));
      return;
    }

    if ((url.includes('extractRefreshes') || url.includes('publishresult'))
      && refreshMode === RefreshModeTypes.Remote) {

        const siteUrls = siteUrlsSelector(appStore.getState());
        Location.instance.setUrl(siteUrls.datasourceLocalExtractRefreshesUrl(dsId));
        return;
    }
  }

  export function isLegacyBridgeScheduleforDataSource(dsInfo: IDataSourceDetailInfo): boolean{
    return dsInfo.refreshMode === RefreshModeTypes.Remote && dsInfo.remoteAgentName &&
      dsInfo.remoteAgentName.length !== 0;
  }

  export function isDataSourceWithLegacyBridgeSchedule(spaceItem: ISpaceTypeInfo): boolean {
      if(spaceItem.contentType !== 'datasource'){
        return false;
      }
      return isLegacyBridgeScheduleforDataSource(spaceItem as IDataSourceDetailInfo);
  }

  export function allDatasourcesHaveLegacyBridgeSchedules(datasources: IDataSourceDetailInfo[]): boolean {
    if(datasources.length === 0){
      return false;
    }
    for(const ds of datasources){
      if(!RefreshPropertyHelper.isLegacyBridgeScheduleforDataSource(ds)){
        return false;
      }
    }
    return true;
  }
}
